const DURATION_RE =
  /^P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;

function format(
  value: number,
  singular: string,
  plural: string,
  hasSmaller: boolean,
): string {
  const noun = value === 1 ? singular : plural;
  const suffix = hasSmaller ? '+' : '';
  return `${value}${suffix} ${noun} left`;
}

export function formatTimeRemaining(isoDuration: string | null): string | null {
  if (isoDuration === null) return null;

  const m = DURATION_RE.exec(isoDuration);
  if (!m) return null;

  const years = +(m[1] ?? 0);
  const months = +(m[2] ?? 0);
  const days = +(m[3] ?? 0);
  const hours = +(m[4] ?? 0);
  const minutes = +(m[5] ?? 0);
  const seconds = +(m[6] ?? 0);

  if (years > 0) {
    const hasSmaller =
      months > 0 || days > 0 || hours > 0 || minutes > 0 || seconds > 0;
    return format(years, 'year', 'years', hasSmaller);
  }
  if (months > 0) {
    const hasSmaller = days > 0 || hours > 0 || minutes > 0 || seconds > 0;
    return format(months, 'month', 'months', hasSmaller);
  }
  if (days > 0) {
    const hasSmaller = hours > 0 || minutes > 0 || seconds > 0;
    return format(days, 'day', 'days', hasSmaller);
  }
  if (hours > 0) {
    const hasSmaller = minutes > 0 || seconds > 0;
    return format(hours, 'hour', 'hours', hasSmaller);
  }
  if (minutes > 0) {
    const hasSmaller = seconds > 0;
    return format(minutes, 'minute', 'minutes', hasSmaller);
  }
  if (seconds > 0) return format(seconds, 'second', 'seconds', false);

  return 'Ending soon';
}
